import config from 'config'
import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import ReactTable from 'srcReact/components/common2/ReactTable'
import Avatar from 'srcReact/components/common2/Avatar'
import { getWorkplaceRoleColor, getWorkplaceMemberSince } from 'srcReact/helpers/utils'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import { workplaceSettingsActions } from 'srcReact/WorkplaceSettingsPage'
import { appConstantSettings } from 'srcReact/appConstantSettings'

const Accepted = ({ selectedWorkplace, setPagination }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    login: { user: loggedInUser },
    workplaceSettings: { manage_invites }
  } = useSelector((state) => state)

  const handleUpdateMemberRole = (userId, role, action) => {
    if (action === 'add') {
      dispatch(workplaceSettingsActions.addWorkplaceMemberRole(selectedWorkplace?.id, userId, role, action))
    } else if (action === 'remove') {
      dispatch(workplaceSettingsActions.removeWorkplaceMemberRole(selectedWorkplace?.id, userId, role, action))
    }
  }
  const handleRemoveMember = (userId) => {
    dispatch(workplaceSettingsActions.removeWorkplaceMember(selectedWorkplace?.id, userId))
  }
  const options = (row) => {
    let isLoggedInUser = row?.member?.id === loggedInUser.id
    let actions = []
    actions.push({
      text: t('global.viewProfile'),
      onClick: () => handleOpenLightModal(row)
    })
    if (!isLoggedInUser && !row?.workplace_role?.includes('workplace-manager')) {
      actions.push({
        text: t('global.makeWorkplaceManager'),
        onClick: () => handleUpdateMemberRole(row?.member?.id, 'workplace-manager', 'add')
      })
    }
    if (!isLoggedInUser && row?.workplace_role?.includes('workplace-manager')) {
      actions.push({
        text: t('global.removeRole'),
        onClick: () => handleUpdateMemberRole(row?.member?.id, 'workplace-manager', 'remove')
      })
    }
    actions.push({
      text: t('global.sendMessage'),
      onClick: () => handleOpenLightModal(row, 'messenger')
    })
    if (!isLoggedInUser && row?.workplace_role?.includes('workplace-member')) {
      actions.push({
        text: t('global.removeMember'),
        onClick: () => handleRemoveMember(row?.member?.id)
      })
    }
    return actions
  }
  const handleOpenLightModal = (row, screen) => {
    const lp = new LightProfileProto()
    lp.userId = row?.member?.id
    lp.screen = screen || 'main'
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }
  const columns = useMemo(
    () => [
      {
        Header: t('workplaceSettings.manageInvites.accepted.member'),
        id: 'name',
        accessor: (row) => (
          <div role='button' className={styles.name} onClick={() => handleOpenLightModal(row)}>
            <Avatar
              imgWrapperSize='tiny'
              userId={row?.member?.id}
              profilePicture={row?.member?.profile_picture}
              firstname={row?.member?.firstname}
              lastname={row?.member?.lastname}
              mimeType={row?.member?.mime_type}
              originalTag={row?.member?.original_tag}
              isOriginal={row?.member?.is_original}
              containerCSS={styles.picture}
              showImageAsDecorative={true}
              withExpertiseGroup={row?.member?.with_expertise_group}
            />
            <div>{row?.member?.firstname + ' ' + row?.member?.lastname}</div>
          </div>
        )
      },
      {
        Header: t('workplaceSettings.manageInvites.accepted.role'),
        id: 'roles',
        accessor: (row) => (
          <div
            className={`${styles.role} ${row?.workplace_role ? styles.workplaceRole : ''}`}
            style={{ backgroundColor: row?.workplace_role !== 'none' && getWorkplaceRoleColor(row?.workplace_role) }}>
            {row?.workplace_role !== 'none' && t(`global.roles.${row?.workplace_role.split(',')[0].replace('-', '_')}`)}
          </div>
        )
      },
      {
        Header: t('workplaceSettings.manageInvites.accepted.memberSince'),
        id: 'sent_at',
        accessor: (row) => (
          <div className={styles.memberSince}>{getWorkplaceMemberSince(row?.sent_at || row?.created_at)}</div>
        ),
        className: styles.rowMemberSince
      },
      {
        Header: t('workplaceSettings.manageInvites.accepted.email'),
        accessor: 'email',
        className: styles.rowEmail
      },
      {
        Header: '',
        id: 'options',
        className: styles.options,
        accessor: (row) => <ReactMenu options={options(row)} />
      }
    ],
    []
  )
  const handleCurrentPage = (page) => {
    const nextOffset = (page - 1) * appConstantSettings.WORKPLACE_PAGINATION_QUANTITY
    setPagination({ nextOffset, isPagination: true })
  }

  return (
    <div className={styles.manageInvitesAccepted}>
      <ReactTable
        columns={columns}
        data={manage_invites?.invitations}
        className={styles.tableClassName}
        loading={manage_invites?.loading}
        pagination={{
          total: manage_invites?.stats?.total,
          offset: manage_invites?.stats?.next_offset
        }}
        pageSize={appConstantSettings.WORKPLACE_PAGINATION_QUANTITY}
        handleCurrentPage={handleCurrentPage}
      />
    </div>
  )
}

export default Accepted
